module.exports = __webpack_public_path__ + "static/img/fb6c025b2f63b197c70933b7ade16d2.eccfc285.jpg";